import styled, { keyframes } from "styled-components";

const spinAnimation = keyframes`
  0% {
    transform: rotate(0turn);
  }
  50% {
    transform: rotate(1.5turn);
  }
  100% {
    transform: rotate(4turn);
  }
`;

export const AnimatedIconWrapper = styled.div`
  line-height: 0;
  flex-shrink: 0;
  animation: ${spinAnimation} 3200ms cubic-bezier(0.4, 0, 0.2, 1) infinite;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacers.L};
  background-color: ${({ theme }) => theme.colors.background.white};
  justify-content: space-around;
  gap: ${({ theme }) => theme.spacers.L};
`;

export const StyledHeader = styled.h1`
  ${({ theme }) => theme.typography.SmallHeadline}
  margin-bottom: ${({ theme }) => theme.spacers.M};
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  text-align: left;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacers.XXL};
  margin-bottom: ${({ theme }) => theme.spacers.XXL};
  margin-top: ${({ theme }) => theme.spacers.XL};
`;

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;
